// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1NxyX","content":"LoadingAlert_content__1DuTA"};